module.exports = __webpack_public_path__ + "static/digitaltrends-3304c2c0692125ebaa14a15c39ee6835.png";